import { useEffect, useState } from "react";
import { api } from "../api";

/**
 * Dropdown de plataformas ativas. Le da BD via /platforms/lookup.
 * Props:
 *  - value: id da plataforma selecionada
 *  - onChange: (id) => void
 *  - placeholder, testid, className, includeEmpty
 */
export default function PlatformPicker({ value = "", onChange, placeholder = "Escolha uma plataforma...", testid = "platform-picker", className = "", includeEmpty = true }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/platforms/lookup").then(({ data }) => setRows(data || [])).catch(() => setRows([]));
  }, []);
  return (
    <select
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      data-testid={testid}
      className={`w-full px-3 py-2 border border-tint rounded-lg text-sm bg-white ${className}`}
    >
      {includeEmpty && <option value="">{placeholder}</option>}
      {rows.map((p) => <option key={p.id} value={p.id}>{p.nome}</option>)}
    </select>
  );
}
